var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-theme-provider',{attrs:{"dark":_vm.dark}},[_c('div',[_c('base-info-card',{attrs:{"title":"Contact","pace":"6"}},[_vm._v(" Pour prendre contact avec moi: ")]),_c('base-business-contact')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }